import styled from 'styled-components';

import { Text, spacing } from '@sine/sine-ui-components';

// Maybe one day their types will be easier...
type AdditionalBlockProps = { spacingBottom?: number };
export const TextBlock = styled(Text).attrs<AdditionalBlockProps, AdditionalBlockProps>((props) => props)`
  display: block;
  margin-bottom: ${({ spacingBottom }) => spacing(spacingBottom || 0)};
`;
